import * as Yup from 'yup';
import type { IncidentReportYesNoOther } from 'components/CriticalIncident/interfaces';
import { yesNoOther, requiredWhenValueIn } from '../utils';

export const initialValues = {
    wereYouRequestedToLeaveEarly: '' as IncidentReportYesNoOther,
    wereYouRequestedToLeaveEarlyOtherReason: '',
    wasOrganizationContactSupportive: '' as IncidentReportYesNoOther,
    wasOrganizationContactSupportiveOtherReason: '',
    wereThereBarriersToIntervention: '' as IncidentReportYesNoOther,
    wereThereBarriersToInterventionOtherReason: '',
    organizationAndManagementSupportSummary: '',
    referrerTitle: '',
    referrerName: '',
    contactRemindedOfCiomAndSurvey: '' as IncidentReportYesNoOther,
    contactRemindedOfCiomAndSurveyOtherReason: '',
    initialContactDate: null,
    contactInformation: '',
    onsiteContactDescription: '',
    agreedActions: '',
    followUpEapServicesAvailable: '',
    overlayingTrendsOrThemes: '',
};

export const validationSchema = Yup.object({
    wereYouRequestedToLeaveEarly: yesNoOther.required('error_required_field'),
    wereYouRequestedToLeaveEarlyOtherReason: Yup.string().when('wereYouRequestedToLeaveEarly', requiredWhenValueIn(['Y', 'O'])),
    wasOrganizationContactSupportive: yesNoOther.required('error_required_field'),
    wasOrganizationContactSupportiveOtherReason: Yup.string().when('wasOrganizationContactSupportive', requiredWhenValueIn(['N', 'O'])),
    wereThereBarriersToIntervention: yesNoOther.required('error_required_field'),
    wereThereBarriersToInterventionOtherReason: Yup.string().when('wereThereBarriersToIntervention', requiredWhenValueIn(['Y', 'O'])),
    organizationAndManagementSupportSummary: Yup.string().optional(),
    referrerTitle: Yup.string().required('error_required_field'),
    referrerName: Yup.string().required('error_required_field'),
    contactRemindedOfCiomAndSurvey: yesNoOther,
    contactRemindedOfCiomAndSurveyOtherReason: Yup.string().when('contactRemindedOfCiomAndSurvey', requiredWhenValueIn(['N', 'O'])),
    initialContactDate: Yup.string().when('contactRemindedOfCiomAndSurvey', {
        is: (value: string) => value === 'Y' || value === 'N',
        then: (schema) => schema.required('error_required_field'),
        otherwise: (schema) => schema.notRequired().nullable(),
    }),
    contactInformation: Yup.string().required('error_required_field'),
    onsiteContactDescription: Yup.string().optional(),
    agreedActions: Yup.string().optional(),
    followUpEapServicesAvailable: Yup.string().optional(),
    overlayingTrendsOrThemes: Yup.string().optional(),
});
